// extracted by css-extract-rspack-plugin
export default {"root":"a4z7CV"};